import { apiClient } from '../api/axios';

export interface LibraryRequest {
    pageNumber: number;
    pageSize: number;
    sortBy: string;
    sortDescending: boolean;
    search: string;
    categoryId: number;
    applicationType: number;
}

export interface LibraryAuthor {
    userId: string;
    username: string;
    lastLogin: string;
    lastPasswordChange: string;
    isVerified: boolean;
    roleId: number;
    personId: string;
    person: {
        personId: string;
        lastName: string;
        firstName: string;
        otherName: string;
        email: string;
        phoneNo: string;
        address: string;
        active: boolean;
        createdDate: string;
        fullName: string;
        qualificationId: number;
        institutionId: number;
        passportUrl: string;
        titleId: number;
        sexId: number;
        dob: string;
        stateId: number;
        state: any;
        rankId: number;
        profileCompleted: boolean;
    };
    role: {
        id: number;
        name: string;
        active: boolean;
        slug: string;
    };
    active: boolean;
    createdDate: string;
}

export interface LibrarySubmission {
    id: string;
    submissionNumber: string;
    abstract: string;
    manuscriptUrl: string;
    isbnNo: string;
    authors: string;
    submittedAt: string;
    authorId: string;
    author: LibraryAuthor;
    title: string;
    status: string;
    applicationType: number;
    cycleId: number;
    cycle: {
        id: number;
        name: string;
        active: boolean;
        submissionReady: boolean;
        tag: string;
    };
    categoryId: number;
    category: {
        id: number;
        name: string;
        code: string;
        active: boolean;
        createdDate: string;
    };
    plagiarismOutcome: number;
}

export interface LibraryResponse {
    isSuccess: boolean;
    message: string;
    data: {
        data: LibrarySubmission[];
        pageNumber: number;
        pageSize: number;
        totalRecords: number;
        totalPages: number;
    };
    errors: string[] | null;
}

export const libraryService = {
    getApprovedSubmissions: async (params: LibraryRequest): Promise<LibraryResponse> => {
        const response = await apiClient.post<LibraryResponse>(
            '/Submissions/GetApprovedSubmissionForLibrary',
            params,
            { skipAuth: true } as any
        );
        return response.data;
    },
};
